import React, {PropsWithChildren} from 'react';
import {Web3Provider} from './providers';
import {Web3ConnectOptions} from './types';

export interface Web3ConnectProps {
  options: Web3ConnectOptions;
}

export const Web3Connect = ({
  children,
  options,
}: PropsWithChildren<Web3ConnectProps>) => {
  return <Web3Provider options={options}>{children}</Web3Provider>;
};
